
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {

    display: block
}

.info-card-wrapper {

    display: flex;

    flex-direction: column
}

idb-content-card:not(:last-of-type) {

    position: relative;

    margin-bottom: 3rem
}
`;